import { FileText, X } from "lucide-react";
import React from "react";
import { useDropzone } from "react-dropzone";

interface FileDropProps {
    fileType: "PDF" | "CSV" | "XML" | "DOC" | "PDF&DOC";
    fileSetter?: (file: File | null) => void;
    file?: File | null;
}

const FileDrop: React.FC<FileDropProps> = ({ fileType, fileSetter, file }) => {
    const [selectedFile, setSelectedFile] = React.useState<File | null>(null);
    const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
        accept:
            fileType === "PDF"
                ? { "application/pdf": [".pdf"] }
                : fileType === "CSV"
                ? { "text/csv": [".csv"] }
                : fileType === "XML"
                ? { "text/xml": [".xml"] }
                : fileType === "DOC"
                ? {
                      "application/msword": [".doc"],
                      "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
                  }
                : fileType === "PDF&DOC"
                ? {
                      "application/pdf": [".pdf"],
                      "application/msword": [".doc"],
                      "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
                  }
                : {},
    });

    React.useEffect(() => {
        if (!file) {
            setSelectedFile(null);
        }
    }, [file]);

    React.useEffect(() => {
        if (acceptedFiles.length) {
            setSelectedFile(acceptedFiles[0]);
            if (fileSetter) {
                fileSetter(acceptedFiles[0]);
            }
        }
    }, [acceptedFiles, fileSetter]);

    return (
        <section className="container">
            <div
                {...getRootProps({ className: "dropzone" })}
                className="flex flex-col items-center justify-center gap-4 rounded-md border border-dashed border-gray-300 bg-gray-100 p-4"
            >
                <input {...getInputProps()} />
                <p className="font-semibold text-gray-700">{`Drag 'n' drop your ${
                    fileType === "PDF&DOC" ? "PDF or DOC" : fileType
                } here, or click to select the ${fileType === "PDF&DOC" ? "PDF or DOC" : fileType}.`}</p>
            </div>
            {selectedFile && (
                <aside className="mt-4 flex flex-col items-center">
                    <div className="relative flex size-16 flex-col items-center gap-2 rounded-lg bg-gray-100 p-4">
                        <X
                            className="absolute -right-2 -top-2 size-6 cursor-pointer rounded-full bg-white p-1 shadow-md"
                            onClick={() => {
                                setSelectedFile(null);
                                if (fileSetter) {
                                    fileSetter(null);
                                }
                            }}
                        />
                        <FileText />
                    </div>
                    <p className="line-clamp-1 max-w-[calc(100vw-150px)]">{selectedFile.name}</p> <p>{(selectedFile.size / 1024).toFixed(2)} kb</p>
                </aside>
            )}
        </section>
    );
};

export default FileDrop;
